module.exports = __webpack_public_path__ + "img/2-1.d2cb054b.png";